<template>
    <van-swipe-cell :on-close="onClose">
        <!-- 八字记录列表元素基类 -->
        <record-item
            v-bind:recordData="recordData"
            v-bind:itemFunc="itemFunc">
        </record-item>
        <template slot="right">
            <div class="com-record-delete">删除</div>
        </template>
    </van-swipe-cell>
</template>

<script>
/**
 * 记录列表可删除元素基类
 */
import RecordItem from './RecordItem.vue'
export default {
    name: 'RecordDeleteItem',
    components: { RecordItem },
    props: {
        recordData: {
            type: Object,
            default () { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return undefined }
        }
    },
    methods: {
        clickRecordItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.recordData);
            }
        },
        onClose(clickPosition, instance) {
            var me = this;
            switch (clickPosition) {
                case 'cell':
                case 'outside':
                    instance.close();
                    break;
                case 'right':
                    this.$dialog.confirm({
                        message: '确定要删除这一条记录吗？'
                    }).then(() => {
                        // on confirm
                        me.$store.dispatch('record/deleteRecordData', me.recordData.id);
                    }).catch(() => {
                        // on cancel
                        instance.close();
                    }); 
                break;
            }
        } 
    }
}
</script>